import React from 'react';
import Options from "./Options";
import AccordionOptions from "./AccordionOptions";
import ReactMarkdown  from "react-markdown/with-html";

import './DefaultCard.css';

export default class extends React.Component {
    constructor(props) {
        super(props);

        const suggestions = { ...props.activity.suggestedActions };
        const title = props.activity.text.includes('|') ?
            props.activity.text.split('|')[3]
            : props.activity.text;

        this.state = {
            activity: props.activity,
            suggestions: suggestions,
            title: title
        };
    }

    cleanSuggestions = () => {
        this.setState({ suggestions: {} });
    }

    render() {
        const {
            state: { suggestions },
            props: { store, accordion }
        } = this;
        let title = this.state.title;

        return (
            <div className={"css-o3xlyv"}>
                <span><ReactMarkdown  source={title} escapeHtml={false}></ReactMarkdown ></span>
                {!accordion ? 
                    <Options suggestions={suggestions} store={store} cleanSuggestions={this.cleanSuggestions} />
                    :
                    <AccordionOptions suggestions={suggestions} store={store}/>
                }                
            </div>
        );
    }
}